import React, { useCallback } from "react";
import { Icon } from "../../shared/icon/Icon";
import { isMobile } from "react-device-detect";
import styles from "./Chat.module.css";
import { toggleChat } from "../../../store/chat-messages/slice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/reducers";
import { ChatBox } from "./ChatBox";

interface ChatProps {
}

export const Chat: React.FC<ChatProps> = () => {
  const { showChat, unreadCount } = useSelector(
    (s: RootState) => s.chatMessages
  );
  const dispatch = useDispatch();

  const handleToggle = useCallback(() => {
    dispatch(toggleChat(!showChat));
  }, [dispatch, showChat]);

  return (
    <div
      className={`${styles["chat-container"]} ${
        isMobile ? styles["none"] : ""
      } ${showChat ? styles["show"] : ""}`}
    >
      <div
        className={`${styles["actions"]} ${
          ( unreadCount > 0 && !showChat ) ? styles["withBadge"] : styles["withoutBadge"]
        }`}
      >
        <button onClick={handleToggle}>
          <Icon id="chat"></Icon>
          { ( unreadCount > 0 && !showChat ) && (
            <span
              className={`${styles["badge"]} ${
                unreadCount > 9 ? styles["big-badge"] : ""
              }`}
            >
              {unreadCount}
            </span>
          )}
        </button>
      </div>
      <ChatBox isShareLayout={false} />
    </div>
  );
};
